/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserGeolocationConsentResponse } from '../../models/user-geolocation-consent-response';

export interface GetGeolocConsent$Params {
  id_user: string;
}

export function getGeolocConsent(
  http: HttpClient,
  rootUrl: string,
  params: GetGeolocConsent$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<UserGeolocationConsentResponse>> {
  const rb = new RequestBuilder(rootUrl, getGeolocConsent.PATH, 'get');
  if (params) {
    rb.path('id_user', params.id_user, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserGeolocationConsentResponse>;
    })
  );
}

getGeolocConsent.PATH = '/v2/users/consent/{id_user}';
